export const propertyResaleVibeReducer = (
  state = {
    vibes: null,
    vibeDetail: null,
    payments: null,   
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "LIST_PROPERTY_RESALE_VIBE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LIST_PROPERTY_RESALE_VIBE_SUCCESS":
      return {
        ...state,
        loading: false,
        vibes: action.payload,
        error: null,
      };
    case "LIST_PROPERTY_RESALE_VIBE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_PROPERTY_RESALE_VIBE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "VIEW_PROPERTY_RESALE_VIBE_SUCCESS":
      return {
        ...state,
        loading: false,
        vibeDetail: action.payload,
        error: null,
      };
    case "VIEW_PROPERTY_RESALE_VIBE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_PROPERTY_RESALE_VIBE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_PROPERTY_RESALE_VIBE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "ADD_PROPERTY_RESALE_VIBE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_PROPERTY_RESALE_VIBE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_PROPERTY_RESALE_VIBE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_PROPERTY_RESALE_VIBE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_PROPERTY_RESALE_VIBE_STATUS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_PROPERTY_RESALE_VIBE_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_PROPERTY_RESALE_VIBE_STATUS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};